<template>
    <div class="template-card-component" :style="{'width':`${cardWidth}px`}">
        <div class="template-card"  @click="toUse()">
            <div class="mask" v-show='mask'>
                <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/replay-btn.png' class="replay-btn"/>
                <p class='replay-txt'>重播</p>
            </div>
            <div class='card-use'>
                <p class='use-txt'>使用量 {{formData(useCount)}}</p>
            </div>
            <slot></slot>
        </div>
        <div class="info">
            <div class='title'>{{title}}</div>
            <div class='user-info'>
                <div class='user'>
                    <div class='user-icon'>
                        <img :src='headIcon' class='user-icon-img' />
                    </div>
                    <div class='user-name'>{{name}}</div>
                </div>
                <div class='likes'>
                    <div class='like-icon'>
                        <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/like-icon.png' class='like-icon-img'/>
                    </div>
                    <div class='like-count'>{{formData(likeCount)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "TemplateCard",
    props: {
        mask:{
            type: Boolean,
            default: false,
        },
        headIcon:{
            type: String,
            default: "",
        },
        name:{
            type: String,
            default: "",
        },
        likeCount:{
            type: [String,Number],
            default: "",
        },
        useCount:{
            type: [String,Number],
            default: "",
        },
        cardWidth:{
            type: [String,Number],
            default: "",
        },
        cardHeight: {
            type: [String,Number],
            default: "",
        },
        coverUrl: {
            type: String,
            default: "",
        },
        videoUrl: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        desc: {
            type: String,
            default: "",
        },
        id:{
            type: Number,
            default: 0,
        },
        index:{
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isPlay: false,
        };
    },
    computed:{
        
    },
    methods: {
        toUse() {
            this.$emit("onUse");
        },
        formData(num){
            num = Number(num)
            if (num >= 10000) {
                return (num / 10000).toFixed(1) + '万';
            } else {
                return num;
            }
        }
    },
    mounted() {
    },
};
</script>

<style lang="less" scoped>
.template-card-component {
    background: #262626;
    border-radius: 0 0 0.16rem 0.16rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0.16rem;
    margin-bottom: 0.14rem;
    overflow: hidden;
    position: relative;
    z-index: 1;
    .template-card {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        .mask{
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 999;
            opacity: 0.8;
            background: #141414;
            border-radius: 0.16rem 0.16rem 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .replay-btn{
                width: 0.96rem;
                opacity: 0.9;
                margin-bottom: 0.12rem;
            }
            .replay-txt{
                font-size: 0.26rem;
                font-family: PingFangTC, PingFangTC-Semibold;
                font-weight: 600;
                text-align: center;
                color:rgb(225,225,225,0.9)
            }
        }
        .card-use{
            position: absolute;
            left: 0.16rem;
            top: 0.16rem;
            opacity: 0.6;
            background: #181818;
            border-radius: 0.50rem;
            padding: 0.1rem 0.16rem;
            //height: 0.45rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            .use-txt{
                margin-top: 0.005rem;
                font-size: 0.18rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                z-index: 999;
                color: #ffffff;
            }
        }
    }
    .info {
        padding:0.28rem 0 0.32rem 0;
        width: 100%;
        background: #262626;
        box-sizing: border-box;
        .title{
            margin-left: 0.24rem;
            font-size: 0.26rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: rgb(225,225,225,0.9);
            margin-bottom: 0.16rem;
            max-width: 2.5rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .user-info{
            margin: 0 0.16rem 0 0.24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 0.28rem;
            .user{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .user-icon{
                    margin-right: 0.12rem;
                    width: 0.28rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    .user-icon-img{
                        width: 0.28rem;
                        border-radius: 50%;
                    }
                }
                .user-name{
                    font-size: 0.2rem;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #8c8c8c;
                    max-width: 1.4rem;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .likes{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .like-icon{
                    width: 0.32rem;
                    margin-right: 0.08rem;
                    display: flex;
                    align-items: center;
                    .like-icon-img{
                        width: 0.32rem;
                    }
                }
                .like-count{
                    font-size: 0.22rem;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #929292;
                }
            }
        }
    }
}
</style>
